export default "__VITE_ASSET__BUoA80vB__"